'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_config$FetchConfig(prestoUrl, eventRouterUrl) {
  this.KO = null;
  this.KN = null;
  this.KO = prestoUrl;
  this.KN = eventRouterUrl;
}
export { $c_Lpresto_config$FetchConfig as $c_Lpresto_config$FetchConfig };
$p = $c_Lpresto_config$FetchConfig.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_config$FetchConfig;
/** @constructor */
function $h_Lpresto_config$FetchConfig() {
}
export { $h_Lpresto_config$FetchConfig as $h_Lpresto_config$FetchConfig };
$h_Lpresto_config$FetchConfig.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_config$FetchConfig) && ((this.KO === x$0.KO) && (this.KN === x$0.KN))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "FetchConfig";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.KO;
  }
  if ((n === 1)) {
    return this.KN;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_config$FetchConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j6)));
}
export { $isArrayOf_Lpresto_config$FetchConfig as $isArrayOf_Lpresto_config$FetchConfig };
var $d_Lpresto_config$FetchConfig = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_config$FetchConfig, "presto.config$FetchConfig", ({
  j6: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_config$FetchConfig as $d_Lpresto_config$FetchConfig };
//# sourceMappingURL=presto.config$-Fetch-Config.js.map
